// Edition offer — the "Ends Sunday" deadline (evergreen, Afroyla pattern): the offer closes at 23:59:59 on the coming
// Sunday in the shopper's own clock (today, if today is Sunday) and rolls to the next Sunday the moment it passes.
// Optional clamp: data-ltr-ed-ends-final="YYYY-MM-DD" on the root — the deadline never lands after that date
// (the last Sunday before Halloween, for the seasonal page). Paints, once per second:
//   [data-ltr-ed-ends-day]   the weekday of the deadline ("Sunday"; "Saturday" when the clamp lands there) → "tonight" on the last day
//   [data-ltr-ed-ends-date]  "Sunday, Sep 20"
//   [data-ltr-ed-countdown]  "3d 06h 51m 20s" (drops the day part inside the last 24 h)
// Loaded by sections/lettoria-dracula-edition.liquid; the close band and the sticky bar reuse the same attributes.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const pad = (n) => String(n).padStart(2, '0');

function parseYmd(ymd) {
  const p = (ymd || '').split('-').map(Number);
  return p.length === 3 && p.every((n) => n > 0) ? new Date(p[0], p[1] - 1, p[2], 23, 59, 59) : null;
}

// the coming Sunday at 23:59:59 local; same day if now is a Sunday before midnight; clamped to `final` while that date is
// still ahead (a clamp already in the past is ignored, so the page never shows a clock stuck at zero)
export function nextSundayEnd(now, finalYmd) {
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
  d.setDate(d.getDate() + ((7 - d.getDay()) % 7));
  const fin = parseYmd(finalYmd);
  return fin && fin.getTime() < d.getTime() && fin.getTime() > now.getTime() ? fin : d;
}

function paint(now) {
  const root = document.querySelector('[data-ltr-ed-ends-final]');
  const end = nextSundayEnd(now, root ? root.getAttribute('data-ltr-ed-ends-final') : '');
  let left = Math.max(0, Math.floor((end.getTime() - now.getTime()) / 1000));
  const days = Math.floor(left / 86400); left -= days * 86400;
  const h = Math.floor(left / 3600); left -= h * 3600;
  const m = Math.floor(left / 60); const s = left - m * 60;
  const clock = `${days > 0 ? `${days}d ` : ''}${pad(h)}h ${pad(m)}m ${pad(s)}s`;
  const sameDay = end.toDateString() === now.toDateString();
  document.querySelectorAll('[data-ltr-ed-countdown]').forEach((el) => { if (el.textContent !== clock) el.textContent = clock; });
  document.querySelectorAll('[data-ltr-ed-ends-day]').forEach((el) => { el.textContent = sameDay ? 'tonight' : DAYS[end.getDay()]; });
  document.querySelectorAll('[data-ltr-ed-ends-date]').forEach((el) => { el.textContent = `${DAYS[end.getDay()]}, ${MONTHS[end.getMonth()]} ${end.getDate()}`; });
}

let timer = null;
function boot() {
  if (!document.querySelector('[data-ltr-ed-countdown], [data-ltr-ed-ends-date]')) return;
  paint(new Date());
  if (timer === null) timer = setInterval(() => paint(new Date()), 1000);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
